import { apiClient } from './client';

export type CrmBriefKind = 'account' | 'conversation' | 'deal';

export interface CrmBriefResult {
  available: boolean;
  summary: string | null;
  error?: string;
}

export interface NextActionSuggestion {
  action: string;
  dueInDays: number | null;
  /** Ready for a date input; null when the suggestion has no natural deadline. */
  dueDate: string | null;
  why: string;
}

export const aiCrmApi = {
  /** Is a provider configured? The screens hide their AI affordances when not. */
  status: async (): Promise<boolean> => {
    const { data } = await apiClient.get('/ai/crm/status');
    return !!data.data.available;
  },
  brief: async (kind: CrmBriefKind, id: string): Promise<CrmBriefResult> => {
    const { data } = await apiClient.post('/ai/crm/brief', { kind, id });
    return data.data;
  },
  nextAction: async (dealId: string): Promise<{ available: boolean; suggestion: NextActionSuggestion | null; error?: string }> => {
    const { data } = await apiClient.post('/ai/crm/next-action', { dealId });
    return data.data;
  },
};
